import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  paymentEventImportSchema,
  paymentEventImportListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import {
  sagaActions,
  updatePaymentEventImport,
} from 'app/ducks/paymentEventImports/actions';
import { PaymentEventImportsActionTypes as types } from 'app/ducks/paymentEventImports/types';

function* createPaymentEventImportSaga(action): any {
  yield put(sagaActions.createPaymentEventImportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentEventImports.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, paymentEventImportSchema);
    const payload = {
      id: response.data.id,
      status: 'processing',
    };
    yield put(updatePaymentEventImport(payload));
    history.push(`/events/imports/${response.data.id}`);
    yield put(sagaActions.createPaymentEventImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPaymentEventImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updatePaymentEventImportSaga(action): any {
  yield put(sagaActions.updatePaymentEventImportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentDataImports.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, paymentEventImportSchema);

    yield put(sagaActions.updatePaymentEventImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePaymentEventImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getPaymentEventImportSaga(action): any {
  yield put(sagaActions.getPaymentEventImportPending());
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentDataImports.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, paymentEventImportSchema);
    yield put(sagaActions.getPaymentEventImportSuccess(normalizedResponse));
    return normalizedResponse.entities.paymentEventImports[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getPaymentEventImportFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllPaymentEventImportsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentEventImportsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.paymentEventImports.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentEventImports.list(action.payload.organisationId, paginationObject);

  if (response) {
    const normalizedResponse = normalize(
      response,
      paymentEventImportListSchema,
    );

    yield put(
      sagaActions.getAllPaymentEventImportsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPaymentEventImportsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPaymentEventImportSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_PAYMENT_EVENT_IMPORT_REQUESTED,
    createPaymentEventImportSaga,
  );
}

function* updatePaymentEventImportSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_PAYMENT_EVENT_IMPORT_REQUESTED,
    updatePaymentEventImportSaga,
  );
}

function* getPaymentEventImportSagaWatcher(): any {
  yield takeLatest(
    types.GET_PAYMENT_EVENT_IMPORT_REQUESTED,
    getPaymentEventImportSaga,
  );
}

function* getAllPaymentEventImportsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_PAYMENT_EVENT_IMPORTS_REQUESTED,
    getAllPaymentEventImportsSaga,
  );
}

export default function* root(): any {
  yield all([
    createPaymentEventImportSagaWatcher(),
    updatePaymentEventImportSagaWatcher(),
    getPaymentEventImportSagaWatcher(),
    getAllPaymentEventImportsSagaWatcher(),
  ]);
}
